import { Text } from "@wojo/ui";
import { Address } from "generated/graphql";
import { parsePhoneNumber, isValidPhoneNumber } from "libphonenumber-js";

export type TravelerContactInfoProps = {
    address?: Address;
    email?: string;
    phoneNumber?: string;
};

export const TravelerContactInfo: React.FC<TravelerContactInfoProps> = ({
    address,
    email,
    phoneNumber,
}) => {
    if (!address && !email && !phoneNumber) {
        return "—";
    }

    return (
        <Text.Body
            variant="2"
            tag="address"
            style={{
                display: "flex",
                flexDirection: "column",
                fontStyle: "normal",
            }}
        >
            {address?.street1 && <span>{address.street1}</span>}
            {address?.street2 && <span>{address.street2}</span>}
            {address?.city && address.state && address.postalCode && (
                <span>{`${address.city}, ${address.state} ${address.postalCode}`}</span>
            )}
            {phoneNumber && isValidPhoneNumber(phoneNumber) && (
                <Text.Body
                    emphasis="1"
                    variant="2"
                    tag="a"
                    href={`tel:${phoneNumber}`}
                >
                    {parsePhoneNumber(phoneNumber).formatNational()}
                </Text.Body>
            )}
            {email && (
                <Text.Body
                    variant="2"
                    emphasis="1"
                    tag="a"
                    href={`mailto:${email}`}
                    style={{
                        overflowWrap: "break-word",
                    }}
                >
                    {email}
                </Text.Body>
            )}
        </Text.Body>
    );
};
